import { UserService } from '@/services/UserService';
import {
  addModalOpenClass,
  formatDate,
  removeModalOpenClass,
} from '@/utils/helper';
import { useEffect, useState } from 'react';
import './OutstandingDues.scss';
import PaymentUI from './PaymentUI';
function OutstandingDues() {
  const [outstandingDues, setOutstandingDues] = useState<number>(0);
  const [selectedAmount, setSelectedAmount] = useState<number>(0);
  const [showPaymentModal, setShowPaymentModal] = useState<boolean>(false);
  const [payPartially, setShowPayPartially] = useState<boolean>(false);
  const [pendingOrders, setPendingOrders] = useState<any[]>([]);
  const [selectedOrders, setSelectedOrders] = useState<{
    [key: string]: boolean;
  }>({});

  useEffect(() => {
    fetchOutstandingDues();
  }, []);

  useEffect(() => {
    if (showPaymentModal) {
      addModalOpenClass();
    } else {
      removeModalOpenClass();
    }
  }, [showPaymentModal]);

  const fetchOutstandingDues = async () => {
    try {
      const response = await UserService.getOutstandingDues();
      if (response?.data?.data) {
        setOutstandingDues(response?.data?.data?.totalAmount);
        setPendingOrders(response?.data?.data?.checks || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onPaymentComplete = () => {
    fetchOutstandingDues();
    setShowPaymentModal(false);
    setShowPayPartially(false);
    setSelectedAmount(0);
    setSelectedOrders({});
  };

  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    const updatedSelectedOrders = { ...selectedOrders };

    if (name === 'all') {
      updatedSelectedOrders.all = checked;
      pendingOrders.forEach((order) => {
        updatedSelectedOrders[order.id] = checked;
      });
    } else {
      updatedSelectedOrders[name] = checked;

      const selectedCount = pendingOrders.filter(
        (order) => updatedSelectedOrders[order.id]
      ).length;
      updatedSelectedOrders.all = selectedCount === pendingOrders.length;
    }

    let selectedOrdersAmount = 0;
    pendingOrders.forEach((order) => {
      if (updatedSelectedOrders[order.id]) {
        selectedOrdersAmount += Math.round(Number(order.total_amount) * 100);
      }
    });
    const payableAmount = selectedOrdersAmount / 100;
    setSelectedAmount(payableAmount);

    setSelectedOrders(updatedSelectedOrders);
  };

  return (
    <div className="profile-main">
      <div className="profile-content">
        <div className="head-profile">
          <h1 className="page-title">OUTSTANDING DUES</h1>
        </div>

        <div className="outstanding-dues-content">
          <div className="due-amount-left">
            <div className="amount-due">
              <label>
                {' '}
                {payPartially ? `Amount Selected to Pay` : `Total Amount Due`}
              </label>
              <span>${payPartially ? selectedAmount : outstandingDues}</span>
            </div>
          </div>
          {outstandingDues > 0 && (
            <div className="due-amount-right">
              <button
                className={`btn btn--${
                  (payPartially && selectedAmount > 0) ||
                  (!payPartially && outstandingDues > 0)
                    ? 'pri'
                    : 'sec'
                } btn--md`}
                disabled={
                  (payPartially && selectedAmount > 0) ||
                  (!payPartially && outstandingDues > 0)
                    ? false
                    : true
                }
                onClick={() =>
                  setShowPaymentModal(() => {
                    if (
                      (payPartially && selectedAmount > 0) ||
                      (!payPartially && outstandingDues > 0)
                    ) {
                      return true;
                    }
                    return false;
                  })
                }
              >
                pay now
              </button>
              {pendingOrders.length > 1 && (
                <span
                  className="pay-partially-btn"
                  onClick={() => {
                    setShowPayPartially(!payPartially);
                    setSelectedAmount(0);
                    setSelectedOrders({});
                  }}
                >
                  {payPartially
                    ? `Cancel Partial Payment`
                    : `Make a Partial Payment`}
                </span>
              )}
            </div>
          )}
          {showPaymentModal && (
            <PaymentUI
              amount={payPartially ? selectedAmount : outstandingDues}
              onClose={() => setShowPaymentModal(false)}
              onPaymentComplete={onPaymentComplete}
              checkIds={
                payPartially
                  ? Object.keys(selectedOrders)
                      .filter((key) => key !== 'all' && selectedOrders[key])
                      .map((key) => Number(key))
                  : pendingOrders.map((order) => order.id)
              }
            />
          )}
        </div>

        <div
          className={`pending-order-list-wrapper ${
            payPartially ? 'pay-partially' : ''
          }`}
        >
          {pendingOrders.length > 0 && (
            <div className="pending-order-list-header">
              {payPartially && (
                <span className="checkbox-ui">
                  <input
                    type="checkbox"
                    name="all"
                    onChange={handleSelect}
                    checked={selectedOrders['all']}
                  />
                </span>
              )}
              <span className="orders">Orders</span>
              <span className="items">Items</span>
              <span className="date">Date</span>
              <span className="amount">Amount</span>
            </div>
          )}
          {pendingOrders.length > 0 &&
            pendingOrders.map((order: any) => (
              <div
                className="pending-order-list"
                key={order.id || order.display_number}
              >
                <div className="pending-order">
                  {payPartially && (
                    <span className="checkbox-ui">
                      <input
                        type="checkbox"
                        name={order.id}
                        onChange={handleSelect}
                        checked={selectedOrders[order.id]}
                      />
                    </span>
                  )}
                  <span className="id">#{order.display_number}</span>
                  <span className="names">
                    {order?.toastOrderDetails
                      ?.map(
                        (detail: any) =>
                          `${detail.quantity} ${detail.display_name}`
                      )
                      .join(', ')}
                  </span>
                  <span className="date">
                    {formatDate(order.opened_date, true)}
                  </span>
                  <span className="amount price">${order.total_amount}</span>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default OutstandingDues;
